"use strict";
/**
 * Created by Mike Naughton on 3/19/18.
 *
 * Dispatcher for actions
 */
Object.defineProperty(exports, "__esModule", { value: true });
var flux_1 = require("flux");
exports.default = new flux_1.Dispatcher();
//# sourceMappingURL=ActionDispatcher.js.map


//////////////////
// WEBPACK FOOTER
// ./public/js/core/operations/ActionDispatcher.js
// module id = 479
// module chunks = 1